module.exports = __webpack_public_path__ + "static/img/02.bd5e997.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/mz_brunegg/02.jpg
// module id = 424
// module chunks = 1